import { Typography } from "@mui/material";
import { ClientType } from "src/services/admin/queries/NetTypes";

export default function Name({ name }: ClientType) {
	return <Typography variant='subtitle2'>{name}</Typography>;
}
